import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNotificationStore } from "../../store/notification.store";
import { NAV_ICONS } from "../icons/navIcons";

export function NotificationBell() {
  const { t } = useTranslation("topbar");
  const { unreadCount, toggle, fetchUnreadCount } = useNotificationStore();

  useEffect(() => {
    fetchUnreadCount();
  }, [fetchUnreadCount]);

  const NotificationIcon = NAV_ICONS.notification;

  return (
    <button
      onClick={toggle}
      title={t("notifications.title")}
      aria-label={t("notifications.title")}
      className="
        relative p-2 rounded-xl
        bg-[rgb(var(--card))]
        border border-[rgb(var(--border))]
        shadow-lifted hover:shadow-lifted-hover
        text-[rgb(var(--text-accent))]
        hover:bg-[rgb(var(--card-muted))]
        transition-all duration-200
      "
    >
      <NotificationIcon size={18} />

      {unreadCount > 0 && (
        <span
          className="
            absolute -top-1 -right-1
            min-w-[18px]
            h-[18px]
            flex items-center justify-center
            rounded-full
            bg-red-600
            text-white
            text-[11px]
            font-semibold
            px-1
          "
        >
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </button>
  );
}
